import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Spinner from '../../components/generics/Spinner';
import _ from 'lodash';
import queryString from 'query-string';

import ReactPaginate from 'react-paginate';

import Filter from '../../components/generics/Filter';
import ReportHeader from '../../components/generics/ReportHeader';
import ReportExpired from '../../components/reports/ReportExpired';

import NoPermissionMessage from '../../components/generics/NoPermissionMessage';

import { fetchLocations, fetchLocationsSuccess, fetchLocationsFailure } from "../../store/inventories/actions";
import {
  fetchExpiredInventoriesReport,
  fetchExpiredInventoriesReportSuccess,
  fetchExpiredInventoriesReportFailure,
  fetchExpiredInventoriesReportCSV,
  fetchExpiredInventoriesReportCSVSuccess,
  fetchExpiredInventoriesReportCSVFailure,
} from "../../store/reports/actions";

import { STARTING_PAGE, DEBOUNCE_SEARCH } from '../../constants/constants';
import { withRouter } from "utils/WithRouter";

export class ReportExpiredContainer extends Component {

  // ---------------------------------------------------------------------------
  // Initialization
  // ---------------------------------------------------------------------------
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      filterFrom: moment().subtract(3, 'week').format('YYYY-MM-DD'),
      filterTo: moment().format('YYYY-MM-DD'),
      searchInventory: '',
      selectedLocationIndex: undefined,
      selectedLocation: undefined,
      selectedPlant: '',
      selectedLot: '',
    };

    this.changeSearch = _.debounce(() => {
      this.searchRefresh()
      this.updateQueryString();
    }, DEBOUNCE_SEARCH);
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const filterFrom = params.from ? params.from : this.state.filterFrom;
    const filterTo = params.to ? params.to : this.state.filterTo;
    const searchInventory = params.search ? params.search : undefined;
    const selectedLocation = params.selectedLocation ? params.selectedLocation : undefined;
    const selectedLocationIndex = params.selectedLocationIndex ? params.selectedLocationIndex : undefined;
    const page = params.page ? params.page : STARTING_PAGE;
    const selectedPlant = params.plant ? params.plant : this.state.selectedPlant;
    const selectedLot = params.lot ? params.lot : this.state.selectedLot;

    // Fetch initial page
    this.setState(
      { page, filterFrom, filterTo, searchInventory, selectedLocation, selectedLocationIndex, selectedPlant, selectedLot },
      () => {
        this.props.getFilteredExpiredReport(page, searchInventory, filterFrom, filterTo, selectedLocation, selectedPlant, selectedLot);
      }
    );

    this.props.fetchLocations();
    this.props.fetchExpiredReportCSV(searchInventory, filterFrom, filterTo, selectedLocation, selectedPlant, selectedLot);
  }

  // ---------------------------------------------------------------------------
  // Filters handling
  // ---------------------------------------------------------------------------

  onFromDateChange = (event) => {
    let filterFrom = event.target.value ? event.target.value : this.state.filterFrom;
    this.setState({ filterFrom, page: STARTING_PAGE }, () => {
        this.updateQueryString();
        this.searchRefresh();
    });
  };

  onToDateChange = (event) => {
    let filterTo = event.target.value ? event.target.value : this.state.filterTo;
    this.setState({ filterTo, page: STARTING_PAGE }, () => {
        this.updateQueryString();
        this.searchRefresh();
    });
  };

  onSearchChange = (event) => {
    let searchInventory = event.target.value ? event.target.value : '';
    this.setState({ searchInventory, page: STARTING_PAGE }, () => {
        this.changeSearch();
    });
  };

  onLocationChange = (event) => {
    let selectedLocationIndex = parseInt(event.target.value, 10) !== -1 ? event.target.value : undefined,
        selectedLocation = selectedLocationIndex ? this.props.locations[selectedLocationIndex].id : undefined;
    this.setState({ selectedLocationIndex, selectedLocation, page:1 }, () => {
      this.updateQueryString();
      this.searchRefresh();
    });
  };

  searchRefresh = () => {
    const { page, searchInventory, filterFrom, filterTo, selectedLocation, selectedPlant, selectedLot } = this.state;
    this.props.getFilteredExpiredReport(page, searchInventory, filterFrom, filterTo, selectedLocation, selectedPlant, selectedLot);
    this.props.fetchExpiredReportCSV(searchInventory, filterFrom, filterTo, selectedLocation, selectedPlant, selectedLot);
  };

  updateQueryString = () => {
    const { filterFrom, filterTo, searchInventory, page, selectedLocation, selectedLocationIndex, selectedPlant, selectedLot } = this.state;
    let params = {};
    if (filterFrom) params.from = filterFrom;
    if (filterTo) params.to = filterTo;
    if (searchInventory) params.search = searchInventory;
    if (selectedLocation) params.selectedLocation = selectedLocation;
    if (selectedLocationIndex) params.selectedLocationIndex = selectedLocationIndex;
    if (selectedPlant) params.plant = selectedPlant;
    if (selectedLot) params.lot = selectedLot;
    params.page = page;
    this.props.history.push({ search: queryString.stringify(params) });
  };

  onPlantChange = (event) => {
    const selectedPlant = event.target.value ? event.target.value : "";
    this.setState({ selectedPlant }, () => {
      this.changeSearch();
    });
  };

  onLotChange = (event) => {
    const selectedLot = event.target.value ? event.target.value : "";
    this.setState({ selectedLot }, () => {
      this.changeSearch();
    });
  };

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    let page = data.selected + 1;
    if(page !== this.state.page){
      this.setState({ page }, () => {
          this.updateQueryString();
          this.searchRefresh();
      });
    };
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render(){
    if (!this.state.filterFrom || !this.state.filterTo){
      return <Spinner />;
    } else {
      return (
        <div>
          <div className="card mb-2">
            <ReportHeader title='Expiration Report'
                          actionTitle='Export CSV'
                          actionClass='btn btn-primary m-0'
                          headers={['ID', 'Item', 'ItemNumber', 'Location', 'PackingDate', 'ReceiveDate', 'DaysOnInventory']}
                          csvData={this.props.expiredInventoriesReportCSV.expiredCSV}
                          csvLoading={this.props.expiredInventoriesReportCSV.loading}
                          filename={`${moment(this.state.filterFrom).format('MMM DD')}-${moment(this.state.filterTo).format('MMM DD')}.csv`}/>
            <Filter
              searchLabel="Search"
              searchPlaceholder="Item Name"
              searchVal={this.state.searchInventory}
              onSearchChange={this.onSearchChange}
              dateLabel="From packing date"
              dateVal={this.state.filterFrom}
              onDateChange={this.onFromDateChange}
              dateLabel2="To packing date"
              dateVal2={this.state.filterTo}
              onDateChange2={this.onToDateChange}
              dropdownLabel="Location"
              dropdownPlaceholder="Location"
              dropdownVal={this.state.selectedLocationIndex}
              onDropdownChange={this.onLocationChange}
              dropdownOptions={this.props.locations}
              searchLabel3="Plant"
              searchPlaceholder3="Search by plant"
              searchVal3={this.state.selectedPlant}
              onSearchChange3={this.onPlantChange}
              searchLabel4="Lot"
              searchPlaceholder4="Search by lot"
              searchVal4={this.state.selectedLot}
              onSearchChange4={this.onLotChange}
            />
          </div>
          <ReportExpired expiredReportEntries={this.props.expiredInventoriesReport.expiredReport}/>
          {this.props.expiredInventoriesReport.pages > 1 &&
            <ReactPaginate pageCount={this.props.expiredInventoriesReport.pages}
                            pageRangeDisplayed={2}
                            marginPagesDisplayed={1}
                            previousLabel="<"
                            nextLabel=">"
                            onPageChange={this.handlePageRequest}
                            initialPage={this.state.page-1}
                            disableInitialCallback={true}
                            containerClassName="pagination"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            activeClassName="page-item active"
                            previousClassName="paginate_button previous"
                            nextClassName="paginate_button next"
                            disabledClassName="page-item disabled"
                            forcePage={this.state.page-1}/>
          }
          {this.props.expiredInventoriesReport.loading ? <Spinner /> : null }
        </div>
      );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    expiredInventoriesReport: state.reports.expiredInventoriesReport,
    expiredInventoriesReportCSV: state.reports.expiredInventoriesReportCSV,
    locations: state.inventories.locationsList.locations,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFilteredExpiredReport: (page, search='', from, to, location=undefined, plant, lot) => {
      dispatch(fetchExpiredInventoriesReport(page, search, from, to, location, plant, lot)).payload.then((response) => {
        dispatch(fetchExpiredInventoriesReportSuccess(response.data));
      }, (error) => {
        dispatch(fetchExpiredInventoriesReportFailure(error));
      });
    },
    fetchLocations: () => {
      dispatch(fetchLocations()).payload.then((response) => {
        dispatch(fetchLocationsSuccess(response.data))
      }, (error) => {
        dispatch(fetchLocationsFailure(error));
      });
    },
    fetchExpiredReportCSV: (search='', from, to, location=undefined, plant, lot) => {
      dispatch(fetchExpiredInventoriesReportCSV(search, from, to, location, plant, lot)).payload.then((response) => {
        dispatch(fetchExpiredInventoriesReportCSVSuccess(response.data));
      }, (error) => {
        dispatch(fetchExpiredInventoriesReportCSVFailure(error));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ReportExpiredContainer));
